var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSimilarwebScraper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 4.44048,
    y1: 0.88619,
    x2: 81.05694,
    y2: 83.47983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#feca82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44319,
    stopColor: "#f47a31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48367,
    stopColor: "#f4732a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c5452a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M78.17747,88.61091c-18.78499,2.12302-37.56996,2.12302-56.35494,0-5.49081-.62055-9.8129-4.94264-10.43345-10.43345-2.12301-18.78497-2.12301-37.56995,0-56.35493.62055-5.49081,4.94265-9.8129,10.43346-10.43345,18.78498-2.12301,37.56995-2.12301,56.35494,0,5.49081.62055,9.8129,4.94264,10.43346,10.43345,2.12301,18.78497,2.12301,37.56995,0,56.35492-.62055,5.49081-4.94265,9.8129-10.43345,10.43345Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M68.09229,38.8591c-2.29804-3.58302-5.62444-6.57621-9.4411-8.09675l-1.12987-.38301c-1.24704-.38548-2.54398-.58551-3.84921-.59366-4.13455.01915-7.48011,3.43939-7.48011,7.66012,0,1.758.58026,3.37428,1.55309,4.66118l-.46727-.61281c.22406.33321.46727.6626.74878.99582,1.18732,1.43627,2.87255,2.92808,5.05568,4.62097,5.37166,4.15562,8.8551,7.84397,9.14235,12.41514.06894.61664.11107,1.24668.11107,1.88439,0,2.32293-.50557,4.78183-1.36733,6.5111h.00766s-.3696.67601-.13788.87325c.11873.1015.37534.1781.82346-.09575,2.40603-1.5655,4.47728-3.59314,6.09362-5.96532,2.38212-3.51127,3.68244-7.64393,3.74005-11.88659.06377-4.24301-1.11949-8.41139-3.40301-11.98809h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M51.7973,54.47617l-3.36471-2.77679c-7.04731-5.14186-10.71268-10.68778-8.70381-17.52636.18193-.62238.40599-1.22753.6626-1.81928v-.00766s.49791-1.04369-.586-.52855c-6.61093,3.58989-10.88013,10.35852-11.27187,17.87106-.25319,4.71337,1.0377,9.38073,3.67686,13.29414,1.06566,1.4965,2.36917,2.80842,3.85879,3.88368h-.00574c7.43032,5.46932,13.80354,2.59104,13.80354,2.59104h.00575c3.23203-1.36403,5.32572-4.53894,5.30655-8.04696.01447-2.71197-1.23684-5.27551-3.38386-6.93241l.00192-.00192Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimilarwebScraper);
export default __webpack_public_path__ + "static/media/similarweb-scraper.d06819b2179975da4287f2437c27adda.svg";
export { ForwardRef as ReactComponent };